import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import { Button, LinearProgress as LoadingOverlay } from '@material-ui/core';
import {
  DataGridPro, useGridApiRef, GridFooter, GridFilterInputValue, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';


import Print from './Print';
import Export from './Export';
import Create from './Create';
import Update from './Update';
import { useAppContext } from '../../../../Context/App/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { get, update, remove, logInAs } from '../../../../Functions/admin';
import { useAdminContext } from '../../../../Context/Admin/Provider';
import { colors, roles, useStateWithCallback } from '../../../../Shared/utils';
import { changeAdminColumns, changeSettings, activeGridFilter, translatedGridFilters } from '../../../../Functions/utils';
import { updateAccountColumnsOrder } from '../../../../Functions/user';

import { decodeHTMLEntities } from '../../../../Functions/utils';

import { logout } from '../../../../Functions/auth';
import { toastTimerValue } from '../../../../Shared/utils';

import '../Admin.css';
import '../../../SweetAlert.css'

export default function AccountsList() {
  const history = useHistory();
  const { t } = useTranslation();
  const apiRef = useGridApiRef();
  // const [{ accountColumns }, dispatch] = useAdminContext();
  const [{ settings, user }, appDispatch] = useAppContext();

  const [{ pickers }] = useReportingContext();
  const tmpLocations = JSON.parse(JSON.stringify(pickers.locations.all));
  const locations = tmpLocations.map(loc => { loc.label = loc.label.replace(/\u2001/g, ''); return loc; });

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [model, setModel] = useStateWithCallback({ filtered: null, selected: [] });

  const [highlightedRow, setHighlightedRow] = useState(null);

  const [reordering, setReordering] = useState(null);
  const [reorderedColumn, setReorderedColumn] = useState("");

  const [oldIndex, setOldIndex] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);

  const [loadedColumnsFromDatabase, setLoadedColumnsFromDatabase] = useState(false);
  const [accountColumnsFromDatabase, setAccountColumnsFromDatabase] = useState({});
  // const [accountColumnsFromDatabase, setAccountColumnsFromDatabase] = useState(
  //   user.accountColumnsOrder ?
  //     JSON.parse(user.accountColumnsOrder)
  //     :
  //     {
  //       id: { hide: true, order: 1, width: 100 },
  //       isActivated: { hide: false, order: 2, width: 100 },
  //       email: { hide: false, order: 3, width: 350 },
  //       contactEmail: { hide: false, order: 4, width: 350 },
  //       latestConnection: { hide: false, order: 5, width: 250 },
  //       role: { hide: false, order: 6, width: 275 },
  //       group: { hide: false, order: 7, width: 300 },
  //       location: { hide: false, order: 8, width: 300 },
  //       actions: { hide: false, order: 9, width: 150 }
  //     }
  // );


  useEffect(() => {
    if (!loadedColumnsFromDatabase) {
      setLoadedColumnsFromDatabase(true);

      const accountColumnsOrder = user.accountColumnsOrder ? JSON.parse(user.accountColumnsOrder) : {};

      const allAccountColumns = {
        id: { hide: true, order: 1, width: 100 },
        isActivated: { hide: false, order: 2, width: 100 },
        email: { hide: false, order: 3, width: 350 },
        contactEmail: { hide: false, order: 4, width: 350 },
        latestConnection: { hide: false, order: 5, width: 250 },
        role: { hide: false, order: 6, width: 275 },
        group: { hide: false, order: 7, width: 300 },
        location: { hide: false, order: 8, width: 300 },
        actions: { hide: false, order: 9, width: 150 }
  }

      for (const key of Object.keys(allAccountColumns)) {
        if (accountColumnsOrder[key]) {
          allAccountColumns[key] = accountColumnsOrder[key];
        }
      }

      const orderedKeys = Object.keys(allAccountColumns)
        .sort((a, b) => {
          return allAccountColumns[a].order > allAccountColumns[b].order ? 1 : -1;
        });

      let i = 1;
      for (const key of orderedKeys) {
        allAccountColumns[key].order = i;
        i++;
      }
      setAccountColumnsFromDatabase(allAccountColumns);
    }
  }, [loadedColumnsFromDatabase]);


  let columns = [];
  if (accountColumnsFromDatabase.id) {
    columns = [ // default visible width: 1500
    {
      field: 'id',
      headerName: 'ID',
      hide: accountColumnsFromDatabase.id.hide,
      filterable: false,
      width: accountColumnsFromDatabase.id.width
    },
    {
        // sortable: false,
      type: 'activeFilter',
      field: 'isActivated',
      hide: accountColumnsFromDatabase.isActivated.hide,
      width: accountColumnsFromDatabase.isActivated.width,
      headerName: t('admin.accounts.columns.active'),

      renderCell: ({ row }) => {
        const icon = (
          <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
            <circle r={3.5} cx={5} cy={5} />
          </svg>
        );

        return (
          <Switch
            checked={row.isActivated}
            onChange={() => toggleActivated(row)}
              // disabled={loading || user.id === row.id}
              disabled={loading || user.id === row.id || (row.email && row.email.includes('DEMO_USER_$'))}
            offHandleColor="#888" onHandleColor="#080"

            checkedIcon={null} uncheckedIcon={null}
            checkedHandleIcon={icon} uncheckedHandleIcon={icon}
          />
        );
      }
    },
    {
      field: 'email',
      hide: accountColumnsFromDatabase.email.hide,
      width: accountColumnsFromDatabase.email.width,
        headerName: t('admin.accounts.columns.email'),
        renderCell: ({ row }) => {

          let txt = row.email;
          if (row.email && row.email.includes('DEMO_USER_$')) {
            if (user.id === row.id)
              txt = "Demo user";
            else
              txt = "Other demo user...";
          }

          return (
            <div>
              {txt}
            </div>
          )
        }
    },
    {
      field: 'contactEmail',
      hide: accountColumnsFromDatabase.contactEmail.hide,
      width: accountColumnsFromDatabase.contactEmail.width,
      headerName: t('admin.accounts.columns.contact_email')
    },
    {
      field: 'latestConnection',
      hide: accountColumnsFromDatabase.latestConnection.hide,
      width: accountColumnsFromDatabase.latestConnection.width,
      headerName: t('admin.accounts.columns.last'),
      align: 'left',
      headerAlign: 'left',
      type: 'date',      
      // valueGetter: (params) => {
      //   const options = {
      //     year: 'numeric',
      //     month: '2-digit',
      //     day: '2-digit',
      //     hour: 'numeric',
      //     minute: '2-digit'
      //   };

      //   if (params.row.latestConnection && params.row.latestConnection !== '')
      //     return new Date(params.row.latestConnection).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
      //   else
      //     return '...';
      // },

      renderCell: ({ row }) => {
        if (row && row.latestConnection) {
          const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit'
          };

          const lastTxt = new Date(row.latestConnection).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
          return (
            <div>
              {lastTxt}
            </div>
          )
        }
        return (
          <div>
            ...
          </div>
        )
      }
    },

    {
      field: 'role',
      type: 'singleSelect',
      valueOptions: [
        t('admin.accounts.types.' + roles.user),
        t('admin.accounts.types.' + roles.admin),
        ...(user.roleId <= roles.stAdmin) ? [t('admin.accounts.types.' + roles.stAdmin)]: [],
        ...(user.roleId <= roles.dashboardSuperAdmin) ? [t('admin.accounts.types.' + roles.dashboardSuperAdmin)]: []       
      ],
      hide: accountColumnsFromDatabase.role.hide,
      width: accountColumnsFromDatabase.role.width,
      headerName: t('admin.accounts.columns.role')
    },
    ...(user.roleId <= roles.stAdmin ? [{
      field: 'group',
      hide: accountColumnsFromDatabase.group.hide,
      width: accountColumnsFromDatabase.group.width,
      headerName: t('admin.accounts.columns.group')
    }] : []),
    ...((user.roleId <= roles.admin) ? [{
      field: 'location',
      hide: accountColumnsFromDatabase.location.hide,
      width: accountColumnsFromDatabase.location.width,
      headerName: t('admin.accounts.columns.location'),

      valueGetter: (params) => {
        const found = locations.find((element) => {
          return element.value === params.row.locations[0] && params.row.locations[0];
        });
        return found && found.label;
      },

      renderCell: ({ row }) => {
        const found = locations.find((element) => {
          return element.value === row.locations[0] && row.locations[0];
        });

        return (
          <div>
            {found && found.label}
          </div>
        )
      }

    }] : []),
    {
      field: 'actions',
      headerName: 'Actions',
      hide: accountColumnsFromDatabase.actions.hide,
      width: accountColumnsFromDatabase.actions.width,

      sortable: false,
      filterable: false,

      align: 'right',
      headerAlign: 'right',

      renderCell: ({ row }) => {
        return (
        <div>
          <Button
                //disabled={loading || (user.id === row.id && row.email.includes('DEMO_USER_$'))}
                disabled={loading || user.id === row.id || (row.email && row.email.includes('DEMO_USER_$'))}
            title={t('global.update')}
            style={{ minWidth: 'unset' }} // Redirect to settings for self changes
            onClick={() => {
                  if (user.id !== row.id)
                    setSelectedUser(row)
                else {

                  Swal.fire({
                    allowOutsideClick: false,
                    title: t('global.dialog_title'),
                    html: t('admin.accounts.update.redirect'),
                    showCancelButton: true,
                    confirmButtonText: t("global.yes"),
                    cancelButtonText: t("global.no"),
                    customClass: {
                      confirmButton: 'confirm-button-class',
                      title: 'title-class',
                      icon: 'icon-class'
                      }
                  }).then((value) => {
                    // console.log("532 - value=", value);

                    if (value && value.isConfirmed) {
                      history.push('/settings');
                    }
                  });
                }
            }}
          >
            <span className="material-icons-outlined" style={{ color: '#222' }}>edit</span>
          </Button>

            {user.roleId <= roles.dashboardSuperAdmin ?
              (
          <Button
            title={t('global.delete')}
            style={{ minWidth: 'unset' }}
            onClick={() => handleDelete(row)}
            disabled={loading || user.id === row.id}
          >
            <span className="material-icons-outlined" style={{ color: '#f22' }}>delete</span>
          </Button>
              ) : (<span></span>)
            }

            {user.roleId <= roles.stAdmin ?
              (
                <Button
                  title={t('admin.accounts.log_in_as.login')}
                  style={{ minWidth: 'unset' }}
                  onClick={() => handleLogInAs(row)}
                  disabled={loading || user.id === row.id}
                >
                  <span className="material-icons-outlined" style={{
                    color: (row.groupV2 || row.groupId === null) ? (
                      (row.roleId === roles.admin && (row.groupId === null)) ||
                        (row.roleId === roles.user && (row.groupId === null || row.locations.length === 0)) ? colors.warning : 'black') : 'lightgrey'
                  }}>login</span>
                </Button>
              ) : (<span></span>)
            }
        </div>
      )
    }
    }
  ] // Keep columns order between sessions
    .sort((a, b) => accountColumnsFromDatabase[a.field].order - accountColumnsFromDatabase[b.field].order);
  }

  const toggleActivated = (user) => {
    setLoading(true);
    user.isActivated = !user.isActivated;

    // locations: null -> Skip adding / removing locations on account update
    update({ type: 'user', user: { ...user, locations: null } }).then(res => {
      setLoading(false);
      if (!res || !res.success) {
        user.isActivated = !user.isActivated;
        return toast(decodeHTMLEntities(t('admin.accounts.errors.' + res, { email: user.email })), { type: 'error' });
      }

      toast(decodeHTMLEntities(t('admin.accounts.' + (res.user.isActivated ? 'activated' : 'deactivated'), { email: user.email })), { type: 'success' });
    });
  };



  const changeColumnsWidth = (col) => {
    const prev = JSON.stringify(accountColumnsFromDatabase);
    let newAccountColumns = accountColumnsFromDatabase;
    newAccountColumns[col.colDef.field].width = col.width;
    const next = JSON.stringify(newAccountColumns);

    if (prev !== next) {
      updateAccountColumnsOrder(newAccountColumns);
      setAccountColumnsFromDatabase(newAccountColumns);

      const newUser = {
        ...user,
        accountColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }
  }


  const changeColumnsVisibility = (col) => {
    const prev = JSON.stringify(accountColumnsFromDatabase);
    let newAccountColumns = accountColumnsFromDatabase;
    newAccountColumns[col.colDef.field].hide = !col.isVisible;
    const next = JSON.stringify(newAccountColumns);

    if (prev !== next) {
      updateAccountColumnsOrder(newAccountColumns);
      setAccountColumnsFromDatabase(newAccountColumns);
      
      const newUser = {
        ...user,
        accountColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }
  }


  // const changeColumnsOrder = (col) => {
  //   const prev = JSON.stringify(accountColumnsFromDatabase);

  //   let newAccountColumns = {}; // accountColumnsFromDatabase;

  //   for (const columnName in accountColumnsFromDatabase) {
  //     const column = accountColumnsFromDatabase[columnName];    
  //     newAccountColumns[columnName] = accountColumnsFromDatabase[columnName];

  //     if (column.order - 1 === col.oldIndex) {
  //       newAccountColumns[columnName].order = col.targetIndex + 1;
  //     }
  //     else {
  //       if (column.order - 1 > col.oldIndex) {
  //         newAccountColumns[columnName].order = newAccountColumns[columnName].order - 1;
  //       }

  //       if (column.order - 1 >= col.targetIndex) {
  //         newAccountColumns[columnName].order = newAccountColumns[columnName].order + 1;
  //       }
  //     }
  //   }
  //   const next = JSON.stringify(newAccountColumns);

  //   if (prev !== next) {
  //     updateAccountColumnsOrder(newAccountColumns);
  //     setAccountColumnsFromDatabase(newAccountColumns);

  //     const newUser = {
  //       ...user,
  //       accountColumnsOrder: next
  //     }
  //     appDispatch({ user: newUser });
  //   }
  // }

  const changeColumnsOrder = (reorderedColumn, oldIndex, targetIndex) => {

    const prev = JSON.stringify(accountColumnsFromDatabase);

    let ecart = targetIndex - oldIndex;
    if (ecart > 0)
      ecart = ecart + 0.5;
    else
      ecart = ecart - 0.5;

    let newAccountColumns = {};
    for (const columnName in accountColumnsFromDatabase) {
      const column = accountColumnsFromDatabase[columnName];

      newAccountColumns[columnName] = accountColumnsFromDatabase[columnName];

      if (columnName === reorderedColumn)
        newAccountColumns[columnName].order = newAccountColumns[columnName].order + ecart;
        }

    const orderedKeys = Object.keys(newAccountColumns)
      .sort((a, b) => {
        return newAccountColumns[a].order > newAccountColumns[b].order ? 1 : -1;
      });

    let i = 1;
    for (const key of orderedKeys) {
      newAccountColumns[key].order = i;
      i++;
      }
    const next = JSON.stringify(newAccountColumns);

    if (prev !== next) {
      updateAccountColumnsOrder(newAccountColumns);
      setAccountColumnsFromDatabase(newAccountColumns);
      
      const newUser = {
        ...user,
        accountColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }

    setReordering(null);
    setReorderedColumn("");
    setOldIndex(null);
    setTargetIndex(null);
  }


  const handleDelete = (user) => {
    // if (window.confirm(t('admin.accounts.delete.confirm', { email: user.email }))) {
    //   setLoading(true);

    //   remove({ type: 'user', id: user.id }).then(res => {
    //     setLoading(false);
    //     if (!res.success) return toast(t('admin.accounts.errors.' + res, { email: user.email }), { type: 'error' });

    //     setUsers(users.filter(row => row.id !== user.id));
    //     toast(t('admin.accounts.delete.success', { email: user.email }), { type: 'success' });
    //   });
    // }

    const newText = user.email.replace(/ /g, ' ');

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.accounts.delete.confirm', { email: newText }),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      inputValidator: (value) => {
        const newValue = value.replace(/ /g, ' ');
        const newEmail = user.email.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, user.email, newValue === user.email);
        if (newValue != newEmail && value != user.email && newValue != user.email) {   // CHECK loc.label === value
          return t('admin.accounts.delete.validation');
        }
        return "";
        },
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then((value) => {
      // console.log("532 - value=", value);

      if (value && value.isConfirmed) {
        const newValue = value && value.value.replace(/ /g, ' ');
        const newEmail = user && user.email && user.email.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, loc.label, newValue === loc.label);
        if (newValue === newEmail || value === user.email || newValue === user.email) {   // CHECK loc.label === value
      setLoading(true);

      remove({ type: 'user', id: user.id }).then(res => {
        setLoading(false);
            if (!res || !res.success) {
              return toast(decodeHTMLEntities(t('admin.accounts.errors.' + res, { email: user.email })), { type: 'error' });
            }

        setUsers(users.filter(row => row.id !== user.id));

            toast(decodeHTMLEntities(t('admin.accounts.delete.success', { email: user.email })), { type: 'success' });
      });
    }
      }
    });
  };

  const handleLogInAs = (user) => {

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.accounts.log_in_as.confirm', { email: user.email }),
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then((value) => {
      // console.log("621 - value=", value);

      if (value && value.isConfirmed) {
      setLoading(true);
      logInAs({ id: user.id }).then(res => {
        setLoading(false);
          if (!res || !res.success) logout().then(() => {
            appDispatch({ user: {} });
            localStorage.clear();
            setTimeout(() => {
              sessionStorage.clear();
            }, 500);
          });

        else {

          // Reset local storage when logging in with a different user
          if (Number(localStorage.getItem('id')) !== res.user.id) {

            localStorage.clear();
            sessionStorage.clear();
            sessionStorage.setItem('redirect', '/reporting');
          }
          localStorage.setItem('id', res.user.id);
          localStorage.setItem('signedIn', res.success);

          // Refresh the whole website state using window.location
          window.location.pathname = sessionStorage.getItem('redirect') ?? '';
        }
      });
    }
    });
  };

  const selectedOption = () => {
    if (!selectedUser) return null;

    // determine if user wants to create or edit an account
    return selectedUser.id ? (
      <Update users={users} setUsers={setUsers} selectedUser={selectedUser} setSelectedUser={setSelectedUser} />
    ) : (
      <Create users={users} setUsers={setUsers} setSelectedUser={setSelectedUser} />
    );
  };

  const rowsToPrint = () => {
    const filtered = model.filtered ?? users;

    // .slice() creates a new array
    const rows = filtered.slice().filter(user => (
      model.selected.length > 0 ? model.selected.includes(user.id) : user.id > 0
    ));

    return rows;
  };

  const updateRowsAndPrint = () => {
    setModel(
      { ...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values()) },
      () => window.print()
    );
  };


  useEffect(() => {
    // console.log("577 - useEffect... users");
    document.title = t('admin.accounts.page');

    if (users.length === 0) {
      get({ type: 'user' }).then(res => {
        setLoading(false);

        if (!res || !res.success) {
          return toast(decodeHTMLEntities(t('admin.accounts.errors.' + res)), { type: 'error' });
        }

        const userRows = [];
        for (const user of res.users) {
          userRows.push({ ...user, role: t('admin.accounts.types.' + user.roleId) });
        }

        setUsers(userRows);
      });
    }
  }, [t, users]);




  // console.log(React.version);
  // console.log("273 - users=", users); 
  // console.log("466 - columns=", columns);
  // console.log("510 - user=", user);
  // console.log("510 - accountColumnsFromDatabase=", accountColumnsFromDatabase);

  //.components && apiRef.current.components.FilterPanel
  // console.log("838 - apiRef=", apiRef.current.state);
  // console.log("840 - users=", users);
  

  useEffect(() => {
    apiRef.current.subscribeEvent('columnHeaderDragStart', (params) => {
      setReordering(true);
      setReorderedColumn("");
      setOldIndex(null);
      setTargetIndex(null);
    });

    apiRef.current.subscribeEvent('columnHeaderDragEnd', (params) => {
      setReordering(false);
    });
  }, [apiRef]);

  useEffect(() => {
    if (reordering === false) {
      changeColumnsOrder(reorderedColumn, oldIndex, targetIndex);
      setReordering(null);
    }
  }, [reordering]);


  return (
    <div id="print-id" className="admin accounts">
      <DataGridPro
        apiRef={apiRef}
        loading={loading}
        // checkboxSelection
        disableSelectionOnClick

        pageSize={settings.pageSize}
        rows={users}
        columns={columns}
        pagination={settings.pagination}

        onSelectionModelChange={selected => setModel({ ...model, selected })}
        columnTypes={{ activeFilter: activeGridFilter(t, GridFilterInputValue) }}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        onColumnWidthChange={(params, event) => {
          changeColumnsWidth(params);
        }}

        onFilterModelChange={(e) => {
          // console.log("865 - e=", e);
          // console.log("871 - apiRef.current.state=", apiRef.current.state);
        }}

        onSortModelChange={(e) => {
          console.log("869 - e=", e);
        }}

        getRowClassName={(params) => {
          return params.id === highlightedRow ? "highlight" : "";
        }}
        onRowClick={o => {
          if (o.id === highlightedRow)
            setHighlightedRow(null);
          else
            setHighlightedRow(o.id)
        }}

        onRowDoubleClick={o => {
          // console.log("878 - o=", o);
          const u = users.find((userElement) => {
            return userElement.id === o.id;
          });

          if (u) {
            if (u.id !== user.id) {
              if (u.email.includes('DEMO_USER_$') == false)
              setSelectedUser(u);
            }
            else {

              Swal.fire({
                allowOutsideClick: false,
                title: t('global.dialog_title'),
                html: t('admin.accounts.update.redirect'),
                showCancelButton: true,
                confirmButtonText: t("global.yes"),
                cancelButtonText: t("global.no"),
                customClass: {
                  confirmButton: 'confirm-button-class',
                  title: 'title-class',
                  icon: 'icon-class'
                }
              }).then((value) => {
                // console.log("532 - value=", value);

                if (value && value.isConfirmed) {
                  history.push('/settings');
                }
              });
            }
          }

          // console.log("884 - u=", u);
        }}

        // onColumnVisibilityChange={col => changeAdminColumns({
        //   column: col.field, columns: accountColumns, dispatch,
        //   view: 'account', type: 'hide', value: !col.isVisible
        // })} // Save hidden column state set by the user


        onColumnVisibilityChange={(params, event) => {
          changeColumnsVisibility(params);
        }}

        onColumnOrderChange={(params, event) => {
          if (oldIndex === null) {
            setReorderedColumn(params.field)
            setOldIndex(params.oldIndex);
          }

          setTargetIndex(params.targetIndex);
          // console.log("params=", params, event);
          //changeColumnsOrder(params);

        }} // Save custom column order set by the user

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        components={{
          ColumnSortedAscendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_upward
            </div>
          ),
          ColumnSortedDescendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_downward
            </div>
          ),
          ColumnUnsortedIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks, opacity: '0.4' }}
            >
              remove
            </div>
          ),
          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">
              <h2>{t('admin.accounts.title')}{'\u2000\u2013\u2000'}
                <span style={{ color: colors.softthinks }}>
                  {loading ? (t('global.loading') + '...') : apiRef.current.getVisibleRowModels().size}
                </span>
              </h2>

              <div className="options">
                <GridToolbarContainer>
                  <GridToolbarFilterButton />
                  <GridToolbarColumnsButton />
                </GridToolbarContainer>
                <span className="separation" />

                <div className="actions">
                  <Export apiRef={apiRef} loading={loading} model={model} setModel={setModel} /> {/* Excel / PDF Download */}
                  <button title={t('global.actions.print')} className="button icon" onClick={updateRowsAndPrint} disabled={loading}>
                    <span className="material-icons-round">print</span> {/* Print */}
                  </button>
                </div>
                <span className="separation" />

                <Button
                  disabled={user.email.includes('DEMO_USER_$')}
                  className="button"
                  onClick={() => setSelectedUser({})}
                  startIcon={<span className="material-icons-round">add_circle_outline</span>}
                >{t('admin.accounts.create.button')}</Button>
              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">
              <GridFooter />
              <div className="checkbox">
                <input
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                  onChange={() => changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch)}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {selectedOption()}

      {(users.length > 0) && <Print accounts={rowsToPrint()} />}
    </div>
  );
}
